import { FormNames, IFormDefinition } from 'models/Form/FormModels'
import { addressInfoFields } from './AddressInfoFields'
import { AppLinks } from 'enviroment/AppLinks'

export const addressInfoForm: IFormDefinition = {
   name: FormNames.AddressInfoForm,
   fields: addressInfoFields,
   labelTextContentPath: "addressInfoFormPage.label",
   urlPath: AppLinks.addressInfoForm,
   nextStepUrlPath: AppLinks.extendedInfoForm,
   canStepBack: true,
   previousStepUrlPath: AppLinks.basicInfoForm,
   subbmitButtonTextContentPath: "addressInfoFormPage.subbmitButtonText"
}